import { action as apiAction } from 'api/Api'

type Payload = {
  cardId: number
  name: string
  description?: string
  validateAddress?: boolean
}

export default (payload: Payload) => async () => {
  const { cardId, name, description = '', validateAddress } = payload

  await apiAction('AddIncomingMail', {
    name,
    description,
    cardId,
    validateAddress
  })
}
